import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createAdminUser = (_, params) => {
  return Api(endPoints.createAdminUser, params, requestType.POST);
};

const getAllAdminUsers = () => {
  return Api(endPoints.getAllAdminUsers, null, requestType.GET);
};

const deleteAdminUser = (id) => {
  return Api(`${endPoints.deleteAdminUser}/${id}`, null, requestType.DELETE);
};

const updateAdminUser = (id, params) => {
  return Api(`${endPoints.updateAdminUser}/${id}`, params, requestType.PUT);
};

const getAllChatsByConversatioId = (id, params) => {
  return Api(
    `${endPoints.getAllChatsByConversatioId}/${id}`,
    params,
    requestType.GET
  );
};

export {
  createAdminUser,
  getAllAdminUsers,
  deleteAdminUser,
  updateAdminUser,
  getAllChatsByConversatioId,
};
